
import { Component, Prop, Vue } from "vue-property-decorator";
import { Mutation } from "vuex-class";

@Component
export default class Link extends Vue {
  @Prop() private color!: string;
}

